import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, checked, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (checked && user) navigate("/admin", { replace: true });
  }, [checked, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-nick-dark flex items-center justify-center px-5 nick-grain">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white rounded-3xl p-8 shadow-xl"
      >
        <Link to="/" className="font-display font-extrabold text-xl tracking-tight">
          Let's Party <span className="text-nick-primary">Houston</span>
        </Link>
        <div className="mt-6 flex items-center gap-2 text-nick-primary">
          <Lock className="h-5 w-5" />
          <span className="overline">Nick's Dashboard</span>
        </div>
        <h1 className="mt-2 font-display font-extrabold text-2xl">Welcome back, Nick.</h1>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="font-semibold">Email</Label>
            <Input data-testid="login-email" type="email" value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-2 h-12 rounded-xl" required />
          </div>
          <div>
            <Label className="font-semibold">Password</Label>
            <Input data-testid="login-password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} className="mt-2 h-12 rounded-xl" required />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive font-medium">{error}</p>}
          <Button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full h-12 rounded-full bg-nick-primary hover:bg-nick-primary-hover text-white font-bold">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Log In"}
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
